import cx from 'classnames'
import React from 'react'

import Link from '@cinch/oxd-components/link/src'
import SVG from '@cinch/oxd-components/svg/src'

import * as styles from './find-your-car.module.css'

interface FindYourCarItem {
  label: string
  icon: string
  url: string
  value: string
}

interface FindYourCar {
  i18n: Cinch.WebAppTranslations['findYourCar']
  items: FindYourCarItem[]
  allCarsUrl: string
}

const FindYourCar: React.FC<FindYourCar> = ({ items, allCarsUrl, i18n }) => {
  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        <ul>
          {items.map((car) => (
            <li key={car.value}>
              <div className={cx(styles.carButton, styles[`car${car.label}`])}>
                <Link
                  className={styles.carLink}
                  to={car.url}
                  tag={{
                    event: 'click',
                    eventCategory: 'link',
                    eventLabel: 'Find your car',
                    eventAction: car.value,
                  }}
                >
                  <SVG children={car.icon} className={styles.carIcon} width={'80%'} />
                  <span className={styles.carLinkLabel}>{car.label}</span>
                </Link>
              </div>
            </li>
          ))}
          <li>
            <Link
              className={styles.allCarsLink}
              to={allCarsUrl}
              tag={{
                event: 'click',
                eventCategory: 'link',
                eventLabel: 'Find your car',
                eventAction: i18n.allCars,
              }}
            >
              {i18n.allCars}
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default FindYourCar
